import { render, staticRenderFns } from "./AccOrderList.vue?vue&type=template&id=2073e5a2"
import script from "./AccOrderList.vue?vue&type=script&lang=js"
export * from "./AccOrderList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports